import { render, staticRenderFns } from "./PatternCard.vue?vue&type=template&id=42ab81f8&scoped=true&lang=pug"
import script from "./PatternCard.vue?vue&type=script&lang=js"
export * from "./PatternCard.vue?vue&type=script&lang=js"
import style0 from "./PatternCard.vue?vue&type=style&index=0&id=42ab81f8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ab81f8",
  null
  
)

export default component.exports